import { render, staticRenderFns } from "./AmChart.vue?vue&type=template&id=0b6ba72e"
import script from "./AmChart.vue?vue&type=script&lang=js"
export * from "./AmChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports